import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import NLPBackendApi from '@infrastructure/backend-apis/nlp/nlp-backend-api'
import { AIPromptsErrorManager } from '@infrastructure/managers/ai/ai-prompts-error-manager'
import { TrackingManager } from '@infrastructure/managers/tracking/tracking-manager'

import { AcademizerCommand } from './command'

@requestHandler(AcademizerCommand)
@injectable()
export class TitleGeneratorHandler
  implements RequestHandler<AcademizerCommand, string[] | undefined>
{
  constructor(
    @inject(NLPBackendApi) private readonly nlpBackendApi: NLPBackendApi,
    @inject(AIPromptsErrorManager) private readonly aiPromptsErrorManager: AIPromptsErrorManager,
    @inject(TrackingManager) private readonly trackingManager: TrackingManager,
  ) {}

  public async handle({ text }: AcademizerCommand): Promise<string[] | undefined> {
    if (!text) {
      this.aiPromptsErrorManager.handleError({
        code: 'error-generating-ai-empty-body',
      })
      return
    }

    try {
      const { ok, result, error } = await this.nlpBackendApi.academizer(text)
      if (!ok) {
        this.trackResult(false)
        this.aiPromptsErrorManager.handleError(error)
        return
      }

      this.trackResult(true)
      return result.results.flatMap((r) => r.rephrases)
    } catch (error: any) {
      this.trackResult(false)
      this.aiPromptsErrorManager.handleError(error)
    }
  }

  private trackResult(ableToRespond: boolean) {
    this.trackingManager.track('ask-ai', 'academizer', { ableToRespond })
  }
}
